module.exports = __webpack_public_path__ + "img/t1.fdd0c9b9.png";